export default __webpack_public_path__ + "static/media/page5.0ed5275c.webp";